/**
 * Der Hauptschalter „Entwickler“ ganz oben auf der Startseite der Einstellungen. (18.10.2026)
 *
 * Martin: „Einen direkten Ein- und Ausschalt-Schalter bei Einstellungen ganz oben, damit ich Entwickler schneller ein- und ausschalten kann.“
 * und: Wenn er ihn aus- und wieder einschaltet, kommen alle drei wieder — ohne dass ihre Einzelschalter sich ändern.
 *
 * Der Schalter schreibt NUR das Feld `entwicklerGesamt` (Vorgabe an) über denselben Weg wie jeder Schalter der Einstellungen
 * (`speichere` der Ansicht). Die Einzelschalter „Entwickler im Chat“, „Zimmermann im Chat“, „Hüter im Chat“ bleiben unberührt;
 * wirksam ist immer Hauptschalter UND Einzelschalter (shared/entwickler-im-chat.ts `entwicklerHauptAn`).
 * ⚠️ `entwicklerGesamt` ist ein Schutz-Feld (shared/einstellung-aendern.ts): nur Martin per Tipp, nie auf Zuruf, nie durch Vespera.
 * ⚠️ Nur Konto 1; jedes andere Konto bekommt kein Element.
 */
import { ENTWICKLER_GESAMT_FELD, entwicklerGesamtAn, entwicklerImChatFuerKonto } from "../../../shared/entwickler-im-chat.js";
import { schalterKnopf } from "./einst-bausteine.js";

export interface SchnellschalterKontext {
  uid: number | null | undefined;
  /** Der Stand der Einstellungen (roh). */
  werte: () => Record<string, unknown>;
  /** Schreibt das Feld (der Speicherweg der Ansicht) und meldet den Satz, sobald gespeichert. */
  speichere: (felder: Record<string, unknown>, satz: string) => void;
}

const SATZ_AN = "Schmied, Zimmermann und Hüter dürfen in den Chat.";
const SATZ_AUS = "Aus: niemand vom Team kommt herein.";

export function baueEntwicklerSchnellschalter(k: SchnellschalterKontext): HTMLElement | null {
  if (!entwicklerImChatFuerKonto(k.uid)) return null;
  const abschnitt = document.createElement("section");
  abschnitt.className = "einst-schnell";
  abschnitt.setAttribute("aria-label", "Entwickler ein- oder ausschalten");
  const text = document.createElement("span");
  text.className = "einst-schnell-text";
  const titel = document.createElement("span");
  titel.className = "einst-schnell-titel";
  titel.textContent = "Entwickler";
  const satz = document.createElement("span");
  satz.className = "einst-schnell-satz";
  satz.id = "einst-schnell-satz";
  satz.setAttribute("role", "status");
  satz.setAttribute("aria-live", "polite");
  text.append(titel, satz);

  const zeige = (an: boolean): void => {
    abschnitt.dataset.zustand = an ? "an" : "aus";
    satz.textContent = an ? SATZ_AN : SATZ_AUS;
  };
  const an = entwicklerGesamtAn(k.werte()[ENTWICKLER_GESAMT_FELD], k.uid);
  const schalter = schalterKnopf("Entwickler", an, (neu) => {
    zeige(neu);
    k.speichere({ [ENTWICKLER_GESAMT_FELD]: neu }, neu ? "Das Entwickler-Team ist eingeschaltet." : "Das Entwickler-Team ist ausgeschaltet.");
  });
  schalter.classList.add("einst-schnell-schalter");
  schalter.setAttribute("aria-describedby", satz.id);
  zeige(an);
  abschnitt.append(text, schalter);
  return abschnitt;
}
